// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { change } from 'redux-form'
import getInitialAntennaLookupValues from 'components/SearchAndSelect/Sets/common/AntennaField/AntennaCode/helpers/getInitialAntennaLookupValues'

const usePathDatabaseSearchAntennaLookup = (sourceForm, lookupFormName) => {
  const dispatch = useDispatch()

  const assignAntenna = useCallback(antenna => {
    dispatch(change(sourceForm, 'antennaCode', antenna?.antennaCode || ''))
    dispatch(change(sourceForm, 'antennaSpecId', antenna?.antennaSpecId || null))
  }, [sourceForm])

  const getLookupTypeProps = useCallback(() => {
    const styles = {
      content: { width: 1000 },
    }

    const {
      initialValues,
      triggerSearchOnMount,
    } = dispatch(getInitialAntennaLookupValues(sourceForm, lookupFormName))

    return {
      initialValues,
      triggerSearchOnMount,
      styles,
    }
  }, [sourceForm])

  return {
    assignAntenna,
    getLookupTypeProps,
  }
}

export default usePathDatabaseSearchAntennaLookup
